const STORAGE_KEY = 'elite-selections';

export function loadSelections() {
    try {
        const saved = localStorage.getItem(STORAGE_KEY);
        return saved ? JSON.parse(saved) : [];
    } catch (error) {
        console.error('Error loading selections:', error);
        return [];
    }
}

export function saveSelections(selections) {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(selections));
    } catch (error) {
        console.error('Error saving selections:', error);
    }
}
